import styled from '@emotion/styled'
import {
    calcRem,
    breakpointSwitch,
    getComponentTheme,
} from '../../../__styling'
import { CardContainer } from '../components/CardContainer'
import { textMixin } from '../../../mixins/TextMixin/TextMixin'

export const Topic = styled.div(({ theme }) => {
    const topicTheme = getComponentTheme(theme, 'leadCard').topic
    return [
        { color: topicTheme.textColor },
        textMixin(theme, topicTheme.textType),
    ]
})

export const ByLine = styled.div(({ theme }) => {
    const bylineTheme = getComponentTheme(theme, 'leadCard').byline
    return [
        { color: bylineTheme.textColor },
        textMixin(theme, bylineTheme.textType),
    ]
})

export const TopicBylineWrapper = styled.div(({ theme }) => {
    return {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        width: '100%',
        textTransform: 'uppercase',
    }
})

export const Headline = styled.div(({ theme }) => {
    const headlineTheme = getComponentTheme(theme, 'leadCard').heading
    return [
        {
            width: '100%',
        },
        textMixin(theme, headlineTheme.textType),
    ]
})

export const LeadCardContainer = styled(CardContainer)(({ theme }) => {
    const marginTop = getComponentTheme(theme, 'leadCard').marginTop
    return [
        {
            alignSelf: 'center',
            // Underline Headline when hovered or active.
            [`&:is(:hover, :focus) ${Headline}`]: {
                textDecoration: 'underline',
            },

            transition: 'margin 0.25s',
        },
        breakpointSwitch(marginTop, (marginTop) => ({
            marginTop,
        })),
    ]
})

export const Teaser = styled.div(({ theme }) => {
    const teaserTheme = getComponentTheme(theme, 'card').teaser
    return [
        {
            width: '100%',
            color: teaserTheme.textColor,
            wordBreak: 'break-word',
        },
        textMixin(theme, teaserTheme.textType),
    ]
})
